// 팝업의 취소버튼
const CancelButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn  cancel' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default CancelButtonBox;
